<script>
    import {fade} from 'svelte/transition';
    import {sgettext} from '../../../i18n.js';
    import Thumbnail from '../../common/Media/Thumbnail.svelte';

    export let d2DocumentMetadata;
    export let d2PreviewUrl = null;

    $: style_class = d2PreviewUrl ? 'meta bgrnd' : '';

    // This legacy Svelte modal has been replaced in react with D2Metadata.tsx
    // This component is still used by the Svelte Activity Diff View when raising a new template for approval

</script>

<div class="prevcontainer">
  {#if d2PreviewUrl}
    <div class="sidenav">
      <div class="media" transition:fade|local>
        <Thumbnail
          width="905px"
          height="100%"
          url={`${d2PreviewUrl}&document_number=${d2DocumentMetadata.r_object_id.value}`}
          media={`${d2PreviewUrl}&document_number=${d2DocumentMetadata.r_object_id.value}`}
          name=""
          type="image"
        />
      </div>
    </div>
  {/if}
  <div class="meta {style_class}">
    {#each Object.entries(d2DocumentMetadata).filter(([key, value]) => !value.label) as [key, data]}
      <p class="metadata-container mb-1">
        <span class="metadata-title">{sgettext(data.name)}:</span>
        {#if data.name == 'Document ID'}
            <a href={d2DocumentMetadata.direct_d2_link.value} class="metadata-value">{data.value}</a>
        {:else}
            <span class="metadata-value">{data.value}</span>
        {/if}
      </p>
    {/each}
  </div>
</div>

<style>
  .metadata-title {
    font-weight: bold;
    font-family: arial, sans-serif;
  }

  .metadata-value {
    color: grey;
  }

  .metadata-container {
    margin: 0;
  }

  .sidenav {
    padding-left: 40px;
    width: 30%;
    height: 100%;
    float: left;
  }

  .meta {
    padding-left: 10px;
    height: 100%;
    float: left;
  }

  .bgrnd {
    padding-left: 40px;
    width: 70%;
  }

  .prevcontainer {
    max-height: 60vh;
    overflow-y: auto;
    margin: auto;
  }
</style>
